import React from "react";
import "./Terms.css";

export default function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <div className="legal-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last Updated: January 2024</p>
        </div>

        <div className="legal-content">
          <section>
            <h2>1. Information We Collect</h2>
            <p>
              At Go With Me Buddy, we collect information to provide you with the best travel connection experience. 
              The information we collect includes:
            </p>
            <ul>
              <li><strong>Account Information:</strong> Name, email address, password, and profile details</li>
              <li><strong>Profile Data:</strong> Travel preferences, interests, and destination choices</li>
              <li><strong>Usage Data:</strong> How you interact with our platform, including searches and connections</li>
              <li><strong>Communication Data:</strong> Messages and interactions with other users and agencies</li>
              <li><strong>Device Information:</strong> IP address, browser type, and device identifiers</li>
            </ul>
          </section>

          <section>
            <h2>2. How We Use Your Information</h2>
            <p>We use the collected information to:</p>
            <ul>
              <li>Provide and maintain our services</li>
              <li>Match you with compatible travel partners</li>
              <li>Connect you with relevant travel agencies</li>
              <li>Improve and personalize your experience</li>
              <li>Send you important updates and notifications</li>
              <li>Ensure platform security and prevent fraud</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section>
            <h2>3. Information Sharing</h2>
            <p>
              We respect your privacy and do not sell your personal information. We may share your information:
            </p>
            <ul>
              <li><strong>With Other Users:</strong> Profile information visible to potential travel partners</li>
              <li><strong>With Travel Agencies:</strong> When you express interest in their services</li>
              <li><strong>Service Providers:</strong> Third-party services that help us operate the platform</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In case of merger, acquisition, or asset sale</li>
            </ul>
          </section>

          <section>
            <h2>4. Data Security</h2>
            <p>
              We implement appropriate technical and organizational measures to protect your personal information. 
              This includes:
            </p>
            <ul>
              <li>Encryption of data in transit and at rest</li>
              <li>Regular security assessments and updates</li>
              <li>Access controls and authentication measures</li>
              <li>Employee training on data protection</li>
            </ul>
            <p>
              However, no method of transmission over the internet is 100% secure. While we strive to protect 
              your data, we cannot guarantee absolute security.
            </p>
          </section>

          <section>
            <h2>5. Your Rights and Choices</h2>
            <p>You have the right to:</p>
            <ul>
              <li><strong>Access:</strong> Request a copy of your personal data</li>
              <li><strong>Correction:</strong> Update inaccurate or incomplete information</li>
              <li><strong>Deletion:</strong> Request deletion of your account and data</li>
              <li><strong>Opt-Out:</strong> Unsubscribe from promotional communications</li>
              <li><strong>Data Portability:</strong> Receive your data in a portable format</li>
              <li><strong>Object:</strong> Object to certain data processing activities</li>
            </ul>
          </section>

          <section>
            <h2>6. Cookies and Tracking</h2>
            <p>
              We use cookies and similar tracking technologies to enhance your experience. You can control 
              cookie preferences through your browser settings. For more information, see our Cookie Policy.
            </p>
          </section>

          <section>
            <h2>7. Data Retention</h2>
            <p>
              We retain your personal information for as long as necessary to provide our services and comply 
              with legal obligations. When you delete your account, we will remove or anonymize your data, 
              except where retention is required by law.
            </p>
          </section>

          <section>
            <h2>8. Children's Privacy</h2>
            <p>
              Our services are not intended for users under 18 years of age. We do not knowingly collect 
              personal information from children. If you believe we have collected information from a child, 
              please contact us immediately.
            </p>
          </section>

          <section>
            <h2>9. International Data Transfers</h2>
            <p>
              Your information may be transferred to and processed in countries other than your own. We ensure 
              appropriate safeguards are in place to protect your data in accordance with this Privacy Policy.
            </p>
          </section>

          <section>
            <h2>10. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of significant changes 
              by posting the new policy on this page and updating the "Last Updated" date.
            </p>
          </section>

          <section>
            <h2>11. Contact Us</h2>
            <p>
              If you have questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <p className="contact-info">
              Email: privacy@gowithmebuddy.com<br />
              Address: Gurgaon, Haryana
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
